import { usePage } from '@inertiajs/react';

const Hero = ({ blok }) => {
    const primaryLink = blok.primary_link?.url || '/glasses';
    const altText = blok.background?.alt || "";
    const invertColors = blok.invertColors || false;
    const { desktopImageUrl, mobileImageUrl } = usePage().props;
    const isMemorialDay = blok.title == 'Memorial Day';

    return (
        <section>
            <div className="banner">
                <a href={primaryLink} className={"block banner-bgc " + (isMemorialDay ? 'memorial-day ' : '') + ((invertColors || isMemorialDay) ? 'no-overlay' : '')}>
                    <picture>
                        {mobileImageUrl && (
                            <source
                                media="(max-width: 767px)"
                                srcSet={mobileImageUrl}
                            />
                        )}
                        {desktopImageUrl && (
                            <source
                                media="(min-width: 768px)"
                                srcSet={desktopImageUrl}
                            />
                        )}
                        <img
                            loading="eager"
                            decoding="async"
                            src={desktopImageUrl || mobileImageUrl}
                            alt={altText}
                            width={desktopImageUrl ? 1912 : 430}
                            height={desktopImageUrl ? 646 : 330}
                            style={{width: '100%', height: 'auto'}}
                        />
                    </picture>
                </a>
                <div className={"banner-info " + (isMemorialDay ? 'memorial-day ' : '') + (invertColors ? 'invert-colors' : '')}>
                    {isMemorialDay ? (
                        <div>
                            <h1 className="banner-info-title">
                                <img src="/img/sales/memorialday2026/memorial-day-trimmed.svg" alt="Memorial Day" />
                            </h1>
                            <p className="banner-info-text desktop">
                                <img src="/img/sales/memorialday2026/30-off-designer-frames-trimmed.svg" alt="30% off designer frames" />
                            </p>
                            <p className="banner-info-text mobile">
                                <img src="/img/sales/memorialday2026/30-off-designer-frames-trimmed-black.svg" alt="30% off designer frames" />
                            </p>
                        </div>
                    ) : (
                        <div>
                            <h1 className="banner-info-title">{blok.title}</h1>
                            <p className="banner-info-text">{blok.description}</p>
                        </div>
                    )}
                    <div className="banner-info-btns">
                        {blok.links.map((link) => (
                            <a key={link._uid} href={link.link.url} className="banner-info-btn">
                                {link.title}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
